import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { setSearchMetrics } from "@/components/CloneView/state/cloneContextReducer";
import { WelcomePage } from "@/components/WelcomePage/WelcomePage";
import { putMetric } from "@/services/api/helpers";
import type { Metric } from "@/services/api/types";
import { mondayService } from "@/services/monday-service";

const metric = {
  name: "StartCloning",
  value: 1,
} as Metric;

export function EmptySection() {
  const history = useHistory();
  const dispatch = useDispatch();

  const onClickInternal = async () => {
    dispatch(setSearchMetrics({ data: [metric], isLoading: false }));
    const sessionToken = await mondayService.getSessionToken();
    await putMetric(metric, sessionToken);
    history.push("/");
  };

  return <WelcomePage onStartCloning={() => void onClickInternal()} />;
}
